// 按钮列表
const buttonList = [
  // 申请状态 10 待审核,20 已通过,30 已拒绝,40 已停用
  {
    label: '全部',
    status: 0,
  },
  {
    label: '待审核',
    status: 10,
  },
  {
    label: '已拒绝',
    status: 30,
  },
  {
    label: '已通过',
    status: 20,
  },
  {
    label: '已停用',
    status: 40,
  },
];

// 表格数据
const tableData = [];

// 弹窗展示控制字段
const dialogVisibleArray = {
  stopVisible: false, // 停用弹窗
  returnVisible: false, // 退回申请弹窗
  enableVisible: false, // 启用弹窗
  refuseVisible: false, // 签约拒绝弹窗
};
// 编辑参数列表
const parmslist = {
  status: '', // 申请状态
  applyNo: '', // 申请编号
};
// 向外暴露，利于外部引用
export { buttonList, tableData, dialogVisibleArray, parmslist };
